export type ShouldRequireCaptchaOptions = {
  environment: string;
  enabledOutsideProduction: boolean;
};

export const shouldRequireCaptcha = ({
  environment,
  enabledOutsideProduction
}: ShouldRequireCaptchaOptions): boolean => {
  return environment === "production" ? true : enabledOutsideProduction;
};
